import React from 'react';

export const Write = () => {
  return (
    <div className="pt-8 p-4 md:pt-16 md:px-8 lg:px-16 text-black">
      <div className="text-center md:text-left">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6">
          Begin Your <br />
          <span className="text-orange-500">Multilingual Chat</span><br />
          Journey With Our App.
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl mb-6 md:mb-8">
          Embark on a seamless multilingual chat experience with our app. Chat effortlessly in any language, anytime, anywhere, with the power of AI translation. Say goodbye to language barriers and connect with ease.
        </p>
      </div>
    </div>
  );
};
